import fetchRefreshToken from './fetchRefreshToken'

const fetchDistribution = async (token) => {
    const response = await fetchRefreshToken().then(async newToken => {
      
      const res = await fetch(`${process.env.REACT_APP_FETCH_DEV}rest/distribution`, {
        method: "GET",
        headers:{
          "Authorization": `Bearer ${newToken}`
        }
      })
      .then(response => response.json())
      return res
    })

    return response
}

  export default fetchDistribution